<template>
  <v-dialog
    v-model="opened"
    persistent
    max-width="310"
    light
  >
    <v-card v-if="item">
      <v-card-title class="headline">
        Supprimer
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        Êtes-vous sûr de vouloir supprimer "{{ item.wtitle }}"
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          small
          @click="deleteItem"
        >
          Supprimer
        </v-btn>

        <v-btn
          color="info"
          small
          @click="closeOnClickOutside"
        >
          Annuler
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { useRoute, useRouter } from 'vue2-helpers/vue-router';
import { useStore } from 'vue2-helpers/vuex';

import { getGraphqlSchema } from '../../graphql/index';
import { EventBus } from '../../mixins';

const route = useRoute();

const router = useRouter();

const item = ref(null);

const opened = ref(false);

const deleting = ref(false);

const type = ref(null);

const store = useStore();

const mutation = computed(() => {
  if (item.value && item.value.isFolder) {
    return getGraphqlSchema('deleteFolder');
  }
  return getGraphqlSchema('deleteFile');
});

const open = newItem => {
  // Disables scroll on the page
  // document.documentElement.style.overflow = 'hidden'

  // Opens dialog box
  opened.value = true;

  // Set's the item to be moved
  item.value = newItem;
};

// eslint-disable-next-line no-undef
defineExpose({ open });

const close = () => {
  // document.documentElement.style.overflow = 'auto'
  opened.value = false;
};

const closeOnClickOutside = () => {
  if (opened.value) {
    EventBus.$emit('unselectItem');
    close();
  }
};

const { mutate: deleteMutation, onDone, onError } = useMutation(mutation, () => ({ variables: { uuid: item.value.uuid } }));

onDone(result => {
  const options = {
    closeable: true,
    timeout: 4000,
    type: 'success'
  };

  let text = `"${item.value.wtitle}" deleted!`;

  if (!result.data[type.value].success) {
    options.type = 'error';
    text = result.data[type.value].message;
  } else {
    // Remove the item from InfoTable.vue
    EventBus.$emit('removeItem', item.value);

    if (['ContentEditor'].includes(route.name)) {
    // If we are in a page of Product, Center etc... redirect to contents
      router.go(-1);
    }
  }

  deleting.value = false;

  // Send a notification event
  EventBus.$emit('show-notification', { text, options });
});

onError(error => {
  const options = {
    closeable: true,
    timeout: 4000,
    type: 'error'
  };

  const text = error.message;

  deleting.value = false;

  // Send a notification event
  EventBus.$emit('show-notification', { text, options });
});

const deleteItem = () => {
  deleting.value = true;

  type.value = item.value.wtype === 'folder' ? 'deleteDir' : 'deleteFile';
  console.log('before', type.value, item.value);
  const options = {
    timeout: 5000,
    type: 'info'
  };

  const text = `Deleting "${item.value.wtitle}"`;

  EventBus.$emit('show-notification', { text, options });

  deleteMutation();

  close();
};

</script>

<style lang="scss">

    .v-card__actions {
        height: 50px;
    }

</style>
